<template>
  <div style="height: calc(100vh - 196px);">
    <vxe-toolbar
      id="toolbarId_electronicReceipt_creditProof"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('electronicReceipt_creditProof_search_button')"
          @click="funcFilter"
          >查询
        </el-button>
        <el-button
          v-if="getLimit('electronicReceipt_multi_apply2')"
          @click="funcMultiApply()"
          >批量申请</el-button
        >
        <el-button
          v-if="getLimit('electronicReceipt_download_button')"
          @click="PDFDownload()"
          >下载电子回单
        </el-button>
        <el-button
          v-if="getLimit('electronicReceipt_creditProof_export_button')"
          @click="funcExport()"
          >导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      show-footer
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      :loading="loading"
      class="mytable-footer"
      height="80%"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="issueId" title="贷款编码" min-width="300" />
        <template v-slot:header>
          <el-input
            v-model="listQuery.issueId"
            placeholder="请输入贷款编码"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="batchId" title="批次号" min-width="280" />
        <template v-slot:header>
          <el-input
            v-model="listQuery.batchId"
            placeholder="请输入批次号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="applyId"
          title="电子回单编号"
          min-width="300"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.applyId"
            placeholder="请输入电子回单编号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="ticketAmt"
          title="金额"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.ticketAmtMin"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.ticketAmtMax"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="receiptStatus"
          title="状态"
          :formatter="formatterReceiptStatus"
          min-width="150"
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.receiptStatus"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in receiptStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" min-width="80" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="
              getLimit('electronicReceipt_creditProof_showFile_button') &&
                scope.row.receiptStatus === 2
            "
            class="item"
            effect="dark"
            content="查看回单"
            placement="top"
          >
            <vxe-button type="text" @click="showElectronicReceipt(scope.row)">
              <i class="el-icon-paperclip" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('electronicReceipt_creditProof_getFile_button') &&
                scope.row.receiptStatus != 2
            "
            class="item"
            effect="dark"
            content="重新申请"
            placement="top"
          >
            <vxe-button type="text" @click="reapplyReceiptStatus(scope.row)">
              <i v-if="scope.row.receiptStatus === 3" class="el-icon-refresh" />
              <i v-else class="el-icon-thumb" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :page-sizes="Pagingconf"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <downloadData ref="downloadRef" />

    <!-- <vxe-modal v-model="modelDetailFlag" title="详情" width="1000" height="600" resize>
      <compDetail ref="detailRef" />
    </vxe-modal> -->
  </div>
</template>
<script>
// import compDetail from "./components/cardTransactionList.vue";
import request from "@/utils/request";

import {
  downLoadCredit,
  getIssueTransferFileBatch
} from "@/api/InternetBanking";
export default {
  name: "CreditProofList",
  components: {
    // compDetail
  },
  data() {
    return {
      exportObj: {
        exportUrl: "/ntocc-tms-api/creditProof/exportElectronicReceipt", //导出接口
        name: "凭证支付"
      },
      message: "",
      loading: false,
      tableData: [],
      modelDetailFlag: false,
      copy: false,
      listQuery: {
        branchCode: "",
        name: "",
        phone: "",
        cardNo: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      // 机构列表
      branchList: this.$store.state.components.branchList,
      value1: "",
      receiptStatusOptions: [
        {
          value: 1,
          label: "处理中"
        },
        {
          value: 2,
          label: "成功"
        },
        {
          value: 3,
          label: "失败"
        }
      ]
    };
  },
  created() {
    this.findList();
  },
  methods: {
    // 批量申请
    funcMultiApply() {
      const selectRecords = this.$refs.xTable.getCheckboxRecords();
      if (!selectRecords || selectRecords.length === 0) {
        this.$message({ message: "请选择需要申请项", type: "warning" });
      } else if (selectRecords.length > 100) {
        this.$message({ message: "批量处理最多100条数据", type: "warning" });
      } else {
        const rLoading = this.openLoading();
        const creditProofCodes = selectRecords.map(item => item.code).join(",");
        getIssueTransferFileBatch({ creditProofCodes }).then(response => {
          rLoading.close();
          let type = response.status === 0 ? "success" : "error";
          this.$message({
            message: response.msg,
            type: type
          });
          this.findList();
        });
      }
    },
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        request({
          url: "/ntocc-tms-api/creditProof",
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    async PDFDownload(item) {
      let checkedRowArray = item
        ? [item]
        : this.$refs.xTable.getCheckboxRecords();
      if (!checkedRowArray || checkedRowArray.length === 0) {
        this.$message.warning("请选择需要打印的项");
        return false;
      } else if (checkedRowArray.length > 20) {
        this.$message.warning("批量处理最多20条数据");
        return false;
      }
      let codes = [];
      for (let subItem of checkedRowArray) {
        codes.push(subItem.code);
      }
      codes = codes.join(",");
      const rLoading = this.openLoading("正在打包请稍后...");
      let response = await downLoadCredit({
        codes
        // isLocalHost: 1
      });
      rLoading.close();
      this.$message.success(response.msg);
      window.open(response.data, "_blank");
    },
    funcLoan(row) {},
    // 详情方法
    funcDetail(params) {
      this.$refs.detailRef.getInfo(params);
      this.modelDetailFlag = true;
    },
    // 公共取消
    fatherCancel(modelFlag) {
      switch (modelFlag) {
        case "detail":
          this.modelDetailFlag = false;
          break;
        default:
      }
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    },
    formatterReceiptStatus({ cellValue }) {
      const item = this.receiptStatusOptions.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    showElectronicReceipt(row) {
      if (row.pdfDownloadUrl) {
        window.open(row.pdfDownloadUrl, "_blank");
      }
    },
    //重新申请电子回单
    reapplyReceiptStatus(row) {
      let code = row.code;
      const rLoading = this.openLoading();
      request({
        url: "/ntocc-tms-api/maYiCreditFlow/getIssueTransferFile",
        method: "post",
        params: {
          creditProofCode: code
        }
      }).then(response => {
        rLoading.close();
        let type = response.status === 0 ? "success" : "error";
        this.findList();
        this.$message({
          message: response.msg,
          type: type
        });
      });
    }
  }
};
</script>
<style></style>
